<!--
  The Title in a page, with styling
-->

<template>
  <h1 class="design-main-title">
    <div class="design-main-title-title">
      <span><slot>{{title}}</slot></span>
    </div>
    <import-export v-if="idField"
      :id-field="idField"
      v-bind="$attrs"
      v-on="$listeners"></import-export>
  </h1>
</template>

<script>
import ImportExport from '../ImportExport.vue'

export default {
  name: 'MainTitle',
  components: {
    ImportExport,
  },
  props: {
    title: String,
    idField: String,
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  h1.design-main-title {
    display: flex;
    justify-content: center;

    .design-main-title-title {
      flex: 1 1;
      min-height: 100%;
      border-left: 5px solid #e92d00;
      & > span {
        display: inline-block;
        margin-left: 1px;
        font-size: 24px;
        padding: 11px;
        padding-right: 0;
        line-height: 1;
        border-left: 5px solid #ebebeb;
      }
    }

    .import-export-group {
      display: flex;
      align-items: center;
    }
  }
</style>
